export const serviceType = {
  hotel: "Hotel",
  flight: "Flight",
  optionalTour: "Optional tour",
  railway: "Railway",
  additionalBaggage: "Additional baggage",
};
